export const strFromSlug = (str: string) =>
  str[0].toUpperCase() + str.substring(1).replace(/_/g, " ");

export default {};
